import { styled, Typography } from "@mui/material";

export const CustomTileContainer = styled("div")(({ theme }) => ({
    minHeight: 104,
    border: `1px solid ${theme.palette.emteria.border.primary}`,
    borderRadius: 8,
    backgroundColor:
        theme.palette.mode === "dark"
            ? theme.palette.emteria.background.paperDeep
            : theme.palette.emteria.text.inverse,
    padding: theme.spacing(2, 4),
    width: "100%",
}));
export const HeaderContainer = styled("div")(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: theme.spacing(1),
}));
export const CustomTileTitle = styled(Typography)(({ theme }) => ({
    fontWeight: 600,
    marginBottom: theme.spacing(1),
    overflowWrap: "break-word",
    wordBreak: "break-word",
    hyphens: "auto",
}));
export const CustomTileText = styled(Typography)(({ theme }) => ({
    color: theme.palette.emteria.text.secondary,
}));
export const CustomTileLink = styled(Typography)(({ theme }) => ({
    cursor: "pointer",
    marginBottom: theme.spacing(1),
    color: theme.palette.emteria.link,
    "&:hover": {
        color: theme.palette.emteria.warning,
    },
}));
